module.exports = "/_next/static/images/87d927466209ab121ca72a7d5a148765-row-1-transfer.svg.webp";